(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6437],{

/***/ 57729:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/announcements/cinch-news/[slug]",
      function () {
        return __webpack_require__(32403);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* reexport safe */ _cinch_nx_landing_feature_articles__WEBPACK_IMPORTED_MODULE_0__.eI; }
/* harmony export */ });
/* harmony import */ var _cinch_nx_landing_feature_articles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44544);
var __N_SSG = true;



/***/ }),

/***/ 44544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eI": function() { return /* reexport */ ArticlesFeature; }
});

// UNUSED EXPORTS: genericArticleStaticPaths, getStaticPathsGenerator, getStaticPropsGenerator

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/landing/ui/articles/src/index.ts + 2 modules
var src = __webpack_require__(313);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 266 modules
var shared_src = __webpack_require__(2388);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 54 modules
var ui_src = __webpack_require__(83624);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../libs/landing/feature-articles/src/lib/articles.module.css
var articles_module = __webpack_require__(44803);
var articles_module_default = /*#__PURE__*/__webpack_require__.n(articles_module);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/lib/components/body/body.tsx




const ArticleBody = ({ body  })=>{
    if (!body || Object.keys(body).length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
        children: (0,shared_src/* renderWithResolver */.be)(body)
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/lib/components/lead-paragraph/lead-paragraph.tsx




const LeadParagraph = ({ body  })=>{
    if (!body || Object.keys(body).length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
        children: (0,shared_src/* renderWithResolver */.be)(body)
    });
};

// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/lib/components/assets/q.svg
var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgQ = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  viewBox: "0 0 22 23"
}, props), _text || (_text = /*#__PURE__*/react.createElement("text", {
  fillRule: "evenodd",
  fontFamily: "BuenosAires-Regular, Buenos Aires",
  fontSize: 24,
  letterSpacing: -0.28,
  transform: "translate(-1 -5)"
}, /*#__PURE__*/react.createElement("tspan", {
  x: 0,
  y: 23
}, "Q."))));
/* harmony default export */ var q = (SvgQ);
// EXTERNAL MODULE: ../../../libs/landing/feature-articles/src/lib/components/related-jargon/related-jargon.module.css
var related_jargon_module = __webpack_require__(38179);
var related_jargon_module_default = /*#__PURE__*/__webpack_require__.n(related_jargon_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/lib/components/related-jargon/related-jargon.tsx







const ArticleRelatedJargon = ({ items  })=>{
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        children: items.length > 0 && items.filter((item)=>item && item.content).map((item, index)=>{
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(shared_src/* Panel */.s_, {
                className: (related_jargon_module_default()).jargon,
                isPadded: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (related_jargon_module_default()).jargonPanelHeader,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* SVG */.Wj, {
                            children: q,
                            hasGradient: true,
                            size: 24,
                            className: (related_jargon_module_default()).icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (related_jargon_module_default()).jargonQuestion,
                        children: (ref = item.content) === null || ref === void 0 ? void 0 : ref.question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (related_jargon_module_default()).jargonSummary,
                        children: (ref1 = item.content) === null || ref1 === void 0 ? void 0 : ref1.summary
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: `/jargon/${item.slug}`,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextLink */.hh, {
                            "data-testid": "jargonLink",
                            className: (related_jargon_module_default()).viewMoreLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "View more"
                            })
                        })
                    })
                ]
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/lib/components/index.ts




;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/lib/articles.tsx









const ArticlesFeature = ({ story , preview  })=>{
    var ref, ref1, ref2, ref3, ref4;
    const typedStory = story;
    const { content  } = (0,storyblok_src/* useStoryblokState */.f0)({
        story: typedStory,
        options: {
            resolveRelations: [
                "ArticleTemplate.relatedJargon"
            ]
        },
        enableBridge: preview
    });
    const { title , subTitle , video , image , leadParagraph , quote , body , SEO  } = content;
    const seoDescription = SEO && ((ref = SEO[0]) === null || ref === void 0 ? void 0 : ref.description);
    const hasRelatedJargon = typedStory.rels && ((ref1 = typedStory.rels) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                fallbackTitle: `${title} - cinch`,
                fallbackDescription: seoDescription || subTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (articles_module_default()).page,
                "data-testid": "article-wrapper",
                children: [
                    SEO && ((ref2 = SEO[0]) === null || ref2 === void 0 ? void 0 : ref2.HowTo) && Array.isArray((ref3 = SEO[0]) === null || ref3 === void 0 ? void 0 : ref3.HowTo) && ((ref4 = SEO[0]) === null || ref4 === void 0 ? void 0 : ref4.HowTo.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* JsonLdScript */.HT, {
                        schema: (0,shared_src/* formatHowToSchema */.Jl)(SEO[0].HowTo),
                        tagId: "HowToPage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* ArticleHeader */.K, {
                                title: title,
                                subTitle: subTitle,
                                video: video,
                                image: image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (articles_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((articles_module_default()).main, {
                                            [(articles_module_default()).mainNoPadding]: !hasRelatedJargon
                                        }),
                                        children: [
                                            (video === null || video === void 0 ? void 0 : video.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Youtube */.hx, {
                                                videoId: video[0].videoId,
                                                title: video[0].title,
                                                buttonLabel: video[0].buttonLabel,
                                                className: (articles_module_default()).video,
                                                customThumbnail: video[0].thumbnail.filename !== "" ? video[0].thumbnail.filename : image.filename,
                                                videoUrlOptions: {
                                                    autoplay: 1
                                                },
                                                showNewPlayIcon: true
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadParagraph, {
                                                body: leadParagraph
                                            }),
                                            quote ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Quote */.pu, {
                                                text: quote
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleBody, {
                                                body: body
                                            })
                                        ]
                                    }),
                                    hasRelatedJargon && /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                                        className: (articles_module_default()).jargonBuster,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleRelatedJargon, {
                                            items: typedStory.rels
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/lib/get-static-paths.tsx


const getStaticPathsGenerator = (slug)=>async ()=>{
        try {
            const links = await getLinks(slug);
            const paths = genericArticleStaticPaths({
                links,
                type: slug
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };

// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/lib/get-static-props.ts



const instrumentedGetStoryBySlug = (0,datadog_server_src/* traceFunction */.KG)("getStoryBySlug", storyblok_src/* getStoryBySlug */.OI);
const getStaticPropsGenerator = ({ path , resolveRelations , passedBreadCrumbs , shouldUndashifyAndCapitalise  })=>{
    return async ({ params , preview =false  })=>{
        const slug = params === null || params === void 0 ? void 0 : params.slug;
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const story = await instrumentedGetStoryBySlug(`${path}/${slug}`, {
                version: preview ? "draft" : "published",
                resolve_relations: resolveRelations
            });
            const breadCrumbs = [
                ...passedBreadCrumbs,
                shouldUndashifyAndCapitalise && {
                    text: undashifyAndCapitalise(slug),
                    url: `/${path}/${slug}`
                }
            ];
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        showBorderRadius: true,
                        breadCrumbs
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            if (typeof error === "string" || error instanceof Error) {
                tagError(error);
            }
            setTag("response.statusCode", 404);
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        showBorderRadius: true,
                        breadCrumbs: []
                    }
                },
                revalidate: 60
            };
        }
    };
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-articles/src/index.ts






/***/ }),

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ ArticleHeader; },
  "T": function() { return /* reexport */ formatFullSlugToPath; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 54 modules
var ui_src = __webpack_require__(83624);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/@mui/material/Skeleton/Skeleton.js + 12 modules
var Skeleton = __webpack_require__(78840);
// EXTERNAL MODULE: ../../../libs/landing/ui/articles/src/lib/components/header/header.module.css
var header_module = __webpack_require__(5300);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/lib/components/header/header.tsx







const ArticleHeader = ({ title , subTitle , image , video  })=>{
    const { isFallback  } = (0,router.useRouter)();
    const prefersReducedMotion = (0,ui_src/* usePrefersReducedMotion */.Tb)();
    if (isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (header_module_default()).header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    sx: {
                        marginBottom: "16px"
                    },
                    animation: prefersReducedMotion ? false : "wave",
                    variant: "rectangular",
                    width: 250,
                    height: 61
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    sx: {
                        marginBottom: "16px"
                    },
                    animation: prefersReducedMotion ? false : "wave",
                    variant: "rectangular",
                    width: 750,
                    height: 56
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (header_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (header_module_default()).title,
                "data-testid": "article-title",
                children: title
            }),
            subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (header_module_default()).subTitle,
                children: subTitle
            }),
            ((video === null || video === void 0 ? void 0 : video.length) ?? 0) <= 0 && (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* BaseCard */.bj, {
                className: (header_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,src/* getStoryblokImageServiceUrl */.Vb)(image.filename, {
                        height: 639,
                        width: 960,
                        filters: [
                            {
                                quality: 80
                            }
                        ],
                        fitIn: {
                            width: 960,
                            height: 639
                        }
                    }),
                    alt: image.alt || "article hero"
                })
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/lib/utils/format-full-slug-to-path/format-full-slug-to-path.ts
/**
 * This takes the `full_slug` string available in Storyblok story object
 * and formats it so it can be used as a pathname.
 * @param fullSlug i.e. 'articles/guides/choosing-a-car/[slug]'
 * @returns An internal pathname string i.e '/guides/choosing-a-car/[slug]'
 */ const formatFullSlugToPath = (fullSlug)=>`/${fullSlug.slice(fullSlug.indexOf("/") + 1)}`;

;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/index.ts




/***/ }),

/***/ 44803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"articles_main__U2nO4","mainNoPadding":"articles_mainNoPadding__8rwTA","content":"articles_content__tUVUx","jargonBuster":"articles_jargonBuster__RaIXE","video":"articles_video__T3_WM"};

/***/ }),

/***/ 38179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jargonBuster":"related-jargon_jargonBuster__Zgcct","jargon":"related-jargon_jargon__aYV6h","jargonPanelHeader":"related-jargon_jargonPanelHeader__5LWZI","jargonQuestion":"related-jargon_jargonQuestion__GOVc2","jargonSummary":"related-jargon_jargonSummary__oWfNi","viewMoreLink":"related-jargon_viewMoreLink__Qo4nf","icon":"related-jargon_icon__HDMg9"};

/***/ }),

/***/ 5300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__bf1yM","title":"header_title__4GtYq","subTitle":"header_subTitle__1gtFs","video":"header_video__Fu0gh","imageWrapper":"header_imageWrapper__48_mj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(57729); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);